import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { X, Heart, ShoppingBag } from "lucide-react";
import { useStore } from "@/context/StoreContext";
import { api, formatPrice } from "@/lib/api";

export default function WishlistDrawer() {
  const { wishlist, wishlistOpen, setWishlistOpen, toggleWishlist, addToCart } = useStore();
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (wishlistOpen) api.getProducts().then(setProducts).catch(() => {});
  }, [wishlistOpen]);

  const items = products.filter((p) => wishlist.includes(p.id));

  return (
    <AnimatePresence>
      {wishlistOpen && (
        <>
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            onClick={() => setWishlistOpen(false)} className="fixed inset-0 z-[60] bg-ink/40 backdrop-blur-sm" />
          <motion.aside
            data-testid="wishlist-drawer"
            initial={{ x: "100%" }} animate={{ x: 0 }} exit={{ x: "100%" }}
            transition={{ type: "spring", stiffness: 260, damping: 32 }}
            className="fixed inset-y-0 right-0 z-[70] w-full max-w-md bg-cream shadow-2xl border-l border-line flex flex-col"
          >
            <div className="flex items-center justify-between px-6 py-5 border-b border-line">
              <div className="flex items-center gap-3">
                <Heart size={18} strokeWidth={1.5} />
                <h3 className="font-serif text-2xl text-ink">Favorite</h3>
              </div>
              <button data-testid="wishlist-close-btn" onClick={() => setWishlistOpen(false)} className="text-ink hover:text-mocha-dark transition-colors"><X size={22} strokeWidth={1.5} /></button>
            </div>

            {items.length === 0 ? (
              <div className="flex-1 flex flex-col items-center justify-center gap-4 text-center px-8">
                <Heart size={40} strokeWidth={1} className="text-mocha" />
                <p className="text-ink-soft">Nu ai niciun parfum la favorite încă.</p>
              </div>
            ) : (
              <div className="flex-1 overflow-y-auto px-6 py-4 space-y-5">
                {items.map((p) => (
                  <div key={p.id} className="flex gap-4">
                    <div className="w-20 h-24 bg-beige overflow-hidden flex-shrink-0 cursor-pointer" onClick={() => { setWishlistOpen(false); navigate(`/parfum/${p.id}`); }}>
                      <img src={p.image} alt={p.name} className="w-full h-full object-cover" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="eyebrow text-[0.55rem] text-mocha-dark">{p.brand}</p>
                      <h4 className="font-serif text-lg text-ink leading-tight truncate">{p.name}</h4>
                      <p className="text-sm text-ink mt-1">{formatPrice(p.price)}</p>
                      <div className="flex items-center gap-3 mt-3">
                        <button onClick={() => addToCart(p)} className="flex items-center gap-2 text-xs uppercase tracking-widest text-ink hover:text-mocha-dark transition-colors"><ShoppingBag size={14} /> Adaugă</button>
                        <button onClick={() => toggleWishlist(p)} className="text-ink-muted hover:text-destructive transition-colors text-xs uppercase tracking-widest">Elimină</button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </motion.aside>
        </>
      )}
    </AnimatePresence>
  );
}
